<template>
  <v-container fluid>
    <v-btn flat @click="submit()"><v-icon>arrow_back_ios</v-icon>&nbsp;Back</v-btn>
    <v-layout justify-center>
      <v-flex xs12 sm6>
        <h2 class="text-lg-right pad-text">
          Choose a {{ timeType || "" }} date
        </h2>
        <div class="text-lg-right">
          <v-btn dark color="primary" @click="submit()">Submit</v-btn>
        </div>
      </v-flex>
      <v-flex xs12 sm6>
        <v-date-picker v-model="date" landscape reactive> </v-date-picker>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "TimePOG",

  props: {
    timeType: String,
  },

  data() {
    return {
      date: null,
    };
  },

  methods: {
    submit() {
      this.$emit("change-date", this.date);
    },
  },
};
</script>

<style scoped>
.pad-text {
  padding: 15px;
}
</style>
